import { mapGetters, mapMutations } from 'vuex';

export const dashboardGraph = {

    computed: {
        ...mapGetters(["getGraph"])
    },

    methods: {
        ...mapMutations(["modifyGraph"]),
    }
};